import { render, staticRenderFns } from "./DialogNotification.vue?vue&type=template&id=c5bd5f10"
import script from "./DialogNotification.vue?vue&type=script&lang=js"
export * from "./DialogNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports